__turbopack_context__.v({
  "link": "sub-nav-item-module-scss-module__vnk-_q__link",
  "linkWrapper": "sub-nav-item-module-scss-module__vnk-_q__linkWrapper",
});
